import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  label?: string;
  dark?: boolean;
};
export function Countdown({
  label = "The special offer ends in:",
  dark
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    unit: "Hours"
  }, {
    value: minutes,
    unit: "Min"
  }, {
    value: seconds,
    unit: "Sec"
  }];
  return <div className="mt-6 text-center" role="timer" aria-live="off" aria-label={`${label} ${hours}:${minutes}:${seconds}`} data-id="element-94" data-mp="3c3z14y5dj0ca">
      <p className={`inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.14em] sm:text-sm ${dark ? "text-gold-light" : "text-navy"}`} data-id="element-95" data-mp="323q27cjzz0t7">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-96" data-mp="10cbtxjiwt5fu" />
        {label}
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" data-id="element-97" data-mp="10a8rg00klju8">
        {units.map((u, i) => <React.Fragment key={u.unit} data-id="element-98" data-mp="15928g2f2fsz5" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-99" data-mp="y0esg83rqo4n">
              <span className={`grid h-[68px] w-[68px] place-items-center rounded-xl font-serif text-[2.1rem] font-bold tabular-nums sm:h-20 sm:w-20 sm:text-[2.5rem] ${dark ? "bg-white text-navy" : "bg-navy text-white"}`} data-id="element-100" data-mp="xytx4g9mr15q">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? "text-white/60" : "text-muted"}`} data-id="element-101" data-mp="f1ixuvo007qa">
                {u.unit}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 font-serif text-3xl font-bold sm:pt-5 ${dark ? "text-gold-light" : "text-navy"}`} aria-hidden="true" data-id="element-102" data-mp="o4bqb28x2php">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}